<template lang="pug">
.w-ctrl-video
  w-playlist-small( v-if='isMultiple' v-bind=`{ playlist, index, size }` )
  w-seek-minimal(
    v-if='isMedia'
    :length='contentLength'
    :size='size'
    :value='playTime'
    @input='seek'
  )
  .buttons
    w-btn-back( v-if='isMultiple' :size='size' @click='back' )
    w-btn-play-pause(
      v-if='isMedia'
      v-bind=`{ size, paused }`
      @play='play'
      @pause='pause'
    )
    w-btn-next( v-if='isMultiple' :size='size' @click='next' )
    .spacer
    w-btn-volume(
      v-if='hasVolume'
      v-bind=`{ size, muted }`
      :value='volume'
      @mute='mute'
      @unmute='unmute'
      @input='setVolume'
    )
</template>

<script lang="js">
import { mapState, mapActions } from 'vuex'
import WPlaylistSmall from '@/widgets/w-playlist-small'
import WSeekMinimal from '@/widgets/w-seek-minimal'
import WBtnPlayPause from '@/widgets/w-btn-play-pause'
import WBtnBack from '@/widgets/w-btn-back'
import WBtnNext from '@/widgets/w-btn-next'
import WBtnVolume from '@/widgets/w-btn-volume'

export default {
  name: 'VideoControlWidget',
  mixins: [],
  components: {
    WPlaylistSmall,
    WSeekMinimal,
    WBtnPlayPause,
    WBtnBack,
    WBtnNext,
    WBtnVolume,
  },
  props: {
    type: {
      type: String,
      default: 'video'
    },
    player: {
      type: Object,
      default: null
    },
    playTime: {
      type: Number,
      default: 0
    },
    playlist: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: 'xl'
    },
    paused: {
      type: Boolean,
      default: null
    },
    muted: {
      type: Boolean,
      default: null
    },
    volume: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions([
      'setPlayingPlay',
      'setPlayingPause',
      'setPlayingMute',
      'setPlayingUnmute',
      'setPlayingVolume',
      'setPlayingSeek',
      'replacePlaying',
    ]),
    play() {
      if ( this.player ) {
        this.$emit( 'play' )
      } else if ( this.playing ) {
        this.setPlayingPlay()
      }
    },
    pause() {
      if ( this.player ) {
        this.$emit( 'pause' )
      } else if ( this.playing ) {
        this.setPlayingPause()
      }
    },
    mute() {
      if ( this.player ) {
        this.$emit( 'mute' )
      } else if ( this.playing ) {
        this.setPlayingMute()
      }
    },
    unmute() {
      if ( this.player ) {
        this.$emit( 'unmute' )
      } else if ( this.playing ) {
        this.setPlayingUnmute()
      }
    },
    setVolume( $event ) {
      if ( this.player ) {
        this.$emit( 'volume', $event )
      } else if ( this.playing ) {
        this.setPlayingVolume( $event )
      }
    },
    seek( $event ) {
      if ( this.player ) {
        this.$emit( 'seek', $event )
      } else if ( this.playing ) {
        this.setPlayingSeek( $event )
      }
    },
    back() {
      if ( this.player ) {
        this.$emit( 'back' )
      } else if ( this.playing ) {
        this.replacePlaying()
      }
    },
    next() {
      if ( this.player ) {
        this.$emit( 'next' )
      } else if ( this.playing ) {
        this.replacePlaying()
      }
    },
  },
  computed: {
    ...mapState([ 'playing' ]),
    isMultiple() { return this.playlist && this.playlist.length > 1 },
    isMedia() { return this.type === 'video' || this.type === 'audio' },
    hasVolume() { return this.isMedia },
    content() { return this.playlist[ this.index ] },
    contentLength() {
      return this.content && this.content.media_details &&
         this.content.media_details.length_formatted
    },
    currentPlayer() {
      return this.player || this.playing
    },
  }
}
</script>

<style lang="scss">
.w-ctrl-video {
  --pad-slider: var(--s-sm);
  position: absolute;
  bottom: var(--spacer-base);
  right: var(--spacer-base);
  .buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    .spacer {
      flex: 1;
    }
  }
}
</style>
